<template>
  <div class="ts-app-shell_fh">
    <div class="padd-main">

      <TSLoading
        :active="loading"
        :defaultMessage="'Please wait...'"
        :altMessage="'Please hold on for a moment while we process the data...'"
      />

      <div class="ts-app-shell--header">
        <h4>Manage Public Profile</h4>
        <div class="ts-app-shell--header_actions flexed">
          <button class="ts-btn ts-btn-small" @click="goBack">Back</button>
        </div>
      </div>
      <el-row class="narrow">
        <el-col class="dashboard-paragraph">
          <p>
            Welcome to your public profile. On this page you can build your
            resume to be available online. Using the QR scanner or url, people
            can see your TalentSensus profile immediately.
          </p>
        </el-col>
      </el-row>

      <el-divider></el-divider>

      <div class="qrcode-banner">
        <QRCodeCard
          :userId="currentUser.id"
          :setToPublic="currentUser.profileIsPublic"
          :fromSettingPage="true"
        >
        </QRCodeCard>
      </div>

      <div class="create-container">
        <button
          v-if="!create"
          class="ts-btn ts-btn-small"
          @click="createNewSetting"
        >
          Build My Resume
        </button>
        <button v-else class="ts-btn ts-btn-small" disabled>
          Build My Resume
        </button>
      </div>

      <div class="create-config-section" style="margin-top:20px;">
        <ProfilePageSettings
          ref="config"
          v-if="create"
          :create="true"
          :setting="profileSettingTemplate"
          :settings="profileSettings"
          @save-setting="saveCreateSetting"
          @cancel-setting="cancelCreateSetting"
        >
        </ProfilePageSettings>
      </div>

      <el-divider></el-divider>

      <div class="config-list-section">
        <h6>Resume List Section</h6>
        <br />
        <br />
        <span style="font-size:13px"
          >The default resume will display all your personal and core strength
          information. Create new resume if you want to choose the information
          you only want to share. You can create multiple resume and set them to
          Active.</span
        ><br /><br />
        <div class="settings-accordion">
          <el-collapse accordion v-model="activeName">
            <el-collapse-item
              v-for="(setting, index) in profileSettings"
              :key="index"
              :name="index"
            >
              <template slot="title">
                <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                  <el-col :xl="22" :lg="22" :md="22" :sm="21" :xs="20">
                    <span
                      v-if="setting.profileName == 'Default'"
                      style="font-weight: bold; font-size: 14px"
                    >
                      Default Resume
                    </span>
                    <span v-else style="font-weight: bold; font-size: 14px">
                      {{ setting.profileName }}
                    </span>
                  </el-col>
                  <el-col :xl="2" :lg="2" :md="2" :sm="3" :xs="4">
                    <span
                      v-if="setting.isActive"
                      style="color: #5ac18e;font-size: 14px;font-weight: bold;"
                    >
                      Active
                    </span>
                    <span
                      v-else
                      style="color: #999999;font-size: 14px;font-weight: bold;"
                    >
                      Inactive</span
                    >
                  </el-col>
                </el-col>
              </template>
              <ProfilePageSettings
                ref="configs"
                :setting="setting"
                @remove-setting="removeCreatedSetting"
                @choose-setting="setSettingToActive"
                @save-update-setting="updateCreatedSetting"
                @cancel-update-setting="cancelCreateSetting"
                @reload-setting="reloadAllSettings"
              >
              </ProfilePageSettings>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>

      <el-divider></el-divider>

      <div class="privacy-config-section" style="margin-bottom:100px;">
        <p>Do you want to publish your profile online?</p>
        <el-switch
          v-model="currentUser.profileIsPublic"
          active-text="Yes"
          inactive-text="No"
          style="padding:15px;"
          @change="setProfilePrivacy"
        ></el-switch>
      </div>
    </div>
  </div>
</template>

<script>
import ProfilePageSettings from "../../../../components/ProfilePageSettings.vue";
import QRCodeCard from "../../../../components/QRCodeCard.vue";
import TSLoading from "../../../../components/TSLoading.vue";

export default {
  components: {
    ProfilePageSettings,
    QRCodeCard,
    TSLoading
  },
  computed: {
    currentUser() {
      return this.$store.state.account.current_user;
    }
  },
  created() {
    this.loading = true;
    this.checkIfUserHaveProfilePageSettingRecord();
  },
  data() {
    return {
      loading: true,
      create: false,
      activeName: null,
      defaultValue: false,
      profileSettings: [],
      profileSettingTemplate: {
        profileConfiguration: {
          personalInformation: {
            email: false,
            address: false,
            phone: false,
            certifications: false,
            certificationsValue: {},
            education: {
              secondaryLevel: false,
              secondaryLevelValue: {},
              thirdLevel: false,
              thirdLevelValue: {},
              fourthLevel: false,
              fourthLevelValue: {}
            }
          },
          coreStrengthInformation: {
            organizationName: false,
            workHistory: false,
            workHistoryValue: {},
            taskDuties: false,
            taskDutiesValue: [],
            activities: false,
            activitiesValue: {},
            sectorExperience: false,
            sectorExperienceValue: {},
            skills: false,
            skillsValue: {},
            knowledge: false,
            knowledgeValue: {},
            essentialSkills: false,
            essentialSkillsValue: {},
            hiddenTalents: false,
            hiddenTalents: []
          }
        }
      },
      sgaValues: {}
    };
  },
  methods: {
    checkIfUserHaveProfilePageSettingRecord() {
      this.$store
        .dispatch(
          "onlineprofile/checkuserprofilepagesetting",
          this.currentUser.id
        )
        .then(res => {
          this.loadAllSettings();
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    reloadAllSettings() {
      this.loading = true;
      window.location.reload();
    },
    loadAllSettings() {
      this.$store
        .dispatch(
          "onlineprofile/getuserprofilepagesettings",
          this.currentUser.id
        )
        .then(res => {
          this.profileSettings = res;
          var val = this.profileSettings.filter(
            x => x.profileName == "Default"
          );
          this.defaultValue = val[0].isActive;

          //assigning the default value to blank resume when creating a new one
          this.sgaValues = { ...val[0] };
        })
        .catch(() => {
          this.loading = false;
        });
    },
    createNewSetting() {
      this.sgaValues.id = null;
      this.sgaValues.profileName = null;
      this.sgaValues.isActive = true;
      this.profileSettingTemplate = this.sgaValues;
      this.create = true;

      var resumeListSectionDisplay = window.innerWidth > 759 ? "block" : "none";
      var resumelistsection = document.getElementsByClassName(
        "config-list-section"
      );
      var publishresumesection = document.getElementsByClassName(
        "privacy-config-section"
      );
      resumelistsection[0].style.display = resumeListSectionDisplay;
      publishresumesection[0].style.display = resumeListSectionDisplay;
    },
    cancelCreateSetting() {
      this.loadAllSettings();
      this.create = false;
      this.activeName = null;

      var resumelistsection = document.getElementsByClassName(
        "config-list-section"
      );
      var publishresumesection = document.getElementsByClassName(
        "privacy-config-section"
      );
      resumelistsection[0].style.display = "block";
      publishresumesection[0].style.display = "block";
    },
    saveCreateSetting(setting) {
      this.loading = true;

      var request = {};
      request.userId = this.currentUser.id;
      request.isActive = setting.isActive;
      request.profileName = setting.profileName;
      request.profileConfiguration = setting.profileConfiguration;

      this.$store
        .dispatch("onlineprofile/saveprofilepagesetting", request)
        .then(() => {
          this.$message.success(`Configuration is created.`);
          this.create = false;
          this.$refs.config.clearFields();
          this.loadAllSettings();
          this.loading = false;
        })
        .catch(() => {
          this.$message.success(`Failed to save the configuration.`);
          this.loading = false;
        });
    },
    updateCreatedSetting(setting, setToActive) {
      if (
        setting.profileConfiguration.personalStatement != null &&
        setting.profileConfiguration.personalStatement != ""
      ) {
        var statement = setting.profileConfiguration.personalStatement.trim();
        if (statement.length <= 150) {
          this.$store
            .dispatch("onlineprofile/saveprofilepagesetting", setting)
            .then(() => {
              this.$message.success(`Configuration updated successfully.`);
              this.loadAllSettings();
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
          this.activeName = null;
        }
      } else {
        this.$store
          .dispatch("onlineprofile/saveprofilepagesetting", setting)
          .then(() => {
            this.$message.success(`Configuration updated successfully.`);
            this.loadAllSettings();
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
        this.activeName = null;
      }
    },
    removeCreatedSetting(setting) {
      this.loading = true;
      this.$store
        .dispatch("onlineprofile/removeprofilepagesetting", setting.id)
        .then(() => {
          this.$message.success(`Configuration removed successfully.`);
          this.loadAllSettings();
          this.loading = false;
        })
        .catch(() => {
          this.$message.success(`Failed to remove configuration.`);
          this.loading = false;
        });
      this.activeName = null;
    },
    setSettingToActive(setting) {
      this.updateCreatedSetting(setting, true);
    },
    setProfilePrivacy() {
      this.loading = true;

      let api = "unpublishprofile";
      if (this.currentUser.profileIsPublic) api = "publishprofile";
      this.$store
        .dispatch(`account/${api}`)
        .then(() => {
          this.$store.dispatch("account/restore").then(() => {
            this.loading = false;
          });
        })
        .catch(() => {
          this.loading = false;
          this.$message.error(`Failed to update profile.`);
        });
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.qrcode-banner {
  height: 230px;
  width: 600px;
  background-color: rgb(179, 240, 255);
  margin: auto;
  padding: 10px;
  text-align: center;
}

@media screen and (max-width: 759px) {
  .qrcode-banner {
    width: unset !important;
    height: unset !important;
  }
}

.create-container {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}
</style>
